<template>
  <div :class="{ 'load load--fill': loading }">
    <Breadcrumbs
      v-if="showBreadcrumbs"
      :current-folder="currentFolderTitle"
      :current-folder-uuid="currentFolderUuid"
      :ancestors="ancestors"
      :shared-item-mode="false"
    />
    <div class="text-center flex justify-center items-center my-4 border border-grey rounded shadow">
      <div class="w-full mb-12">
        <h1>
          Edit Sharing:
          <span
            class="font-semibold text-grey-darkest"
            v-html="resourceTitle"
          />
        </h1>

        <!--
                <div class="flex justify-center items-baseline mt-4" v-if="visibilities.length">
                    <div class="input-group">
                        <input type="text" v-model="search" placeholder="Search">
                    </div>
                    <div class="text-xs pl-4">
                        <a href="#" @click.prevent="selectAll">Select All</a>
                        | <a href="#" @click.prevent="selectNone">Select None</a>
                    </div>
                </div>
                -->

        <div class="flex justify-between items-baseline px-8 border-b border-grey w-full">
          <h3
            class="font-bold text-grey-dark"
            v-text="'Organizations'"
          />
          <a
            href="#"
            class="btn btn--sm"
            @click.prevent="openSendToOrganizationsModal"
            v-text="'Add Organizations'"
          />
        </div>
        <ul
          v-if="filteredShares.length && !loading"
          class="list-reset flex-wrap flex mx-6"
        >
          <li
            v-for="share in filteredShares"
            :key="share.uuid"
            class="w-1/5 flex items-top"
          >
            <div class="border rounded w-full mx-4 p-3 border-grey-dark my-2 flex items-center">
              <input
                :id="`share-${share.uuid}`"
                :key="share.uuid"
                v-model="selectedShares"
                type="checkbox"
                :name="`share-${share.uuid}`"
                :value="share.uuid"
              >
              <label
                :for="`share-${share.uuid}`"
                class="mb-0 w-full text-left"
                v-text="share.receiver.attributes.name"
              />
            </div>
          </li>
        </ul>
        <div
          v-if="!filteredShares.length && !loading"
          class="font-extrabold items-stretch m-4 text-3xl text-grey-dark"
          v-text="'This item has not been shared yet.'"
        />
        <div
          v-if="filteredShares.length"
          class="flex justify-start mx-8 mb-6 items-baseline"
        >
          <button
            type="button"
            class="btn btn--danger mx-2"
            @click.prevent="removeOrganizations"
            v-text="'Remove sharing'"
          />
          <a
            :href="folderDetailsUrl"
            class="text-grey-darker mx-8"
            v-text="'Cancel'"
          />
        </div>
      </div>
    </div>
    <SendToOrganizationsModal
      @folderHasBeenSentToOrganizations="fetch"
      @documentHasBeenSentToOrganizations="fetch"
    />
  </div>
</template>

<script type="text/babel">
import Breadcrumbs from './FolderBreadcrumbs'
import SendToOrganizationsModal from './_modals/SendToOrganizationsModal'

export default {
  name: 'SharingEditor',
  components: {
    Breadcrumbs,
    SendToOrganizationsModal,
  },
  props: {
    resourceUuid: {
      type: String,
      required: true,
    },
    resourceType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      search: '',
      selectedShares: [],
      resource: {
        _type: null,
        uuid: '',
        attributes: {
          title: '',
        },
        ancestors: {
          data: [],
        },
        shares: {
          data: [],
        },
        // Folder is set here in case the resource is a document
        folder: {
          uuid: '',
          ancestors: {
            data: [],
          },
          attributes: {
            title: '',
          },
        },
      },
    }
  },
  computed: {
    fetchUrl() {
      switch (this.resourceType.toLowerCase()) {
        case 'folder':
          return `${this.resourceType.toLowerCase()}s/${this.resourceUuid}?include=shares,ancestors`
        case 'document':
          return `${this.resourceType.toLowerCase()}s/${this.resourceUuid}?include=folder.ancestors,shares`
        default:
          throw 'Invalid resource type'
      }
    },
    removeSharesUrl() {
      return `${this.resourceType.toLowerCase()}s/${this.resourceUuid}/shares/delete`
    },
    showBreadcrumbs() {
      return true
    },
    resourceTitle() {
      return this.resource.attributes.title
    },
    currentFolderTitle() {
      switch (this.resourceType.toLowerCase()) {
        case 'folder':
          return this.resource.attributes.title
        case 'document':
          return this.resource.folder.attributes.title
      }

      throw 'Could not generate Folder Title'
    },
    currentFolderUuid() {
      switch (this.resourceType.toLowerCase()) {
        case 'folder':
          return this.resource.uuid
        case 'document':
          return this.resource.folder.uuid
      }

      throw 'Could not generate Folder Uuid'
    },
    folderDetailsUrl() {
      switch (this.resourceType.toLowerCase()) {
        case 'folder':
          return this.$urlGenerator.active(`documents/folders/${this.resource.uuid}`)
        case 'document':
          return this.$urlGenerator.active(`documents/folders/${this.resource.folder.uuid}`)
      }

      throw 'Could not generate Folder Details URL'
    },
    ancestors() {
      switch (this.resourceType.toLowerCase()) {
        case 'folder':
          return this.resource.ancestors.data
        case 'document':
          return this.resource.folder.ancestors.data
      }

      return []
    },
    shares() {
      return this.resource.shares.data
    },
    filteredShares() {
      if (this.shares.length) {
        return this.shares.filter((share) => {
          const name = share.receiver.attributes.name.toLowerCase()

          return name.includes(this.search.toLowerCase())
        })
      }

      return []
    },
  },
  async mounted() {
    await this.$nextTick()

    this.fetch()
  },
  methods: {
    fetch() {
      this.loading = true

      this.$api.active().get(this.fetchUrl).then((response) => {
        this.resource = response.data
        this.loading = false
      })
    },
    removeOrganizations() {
      this.$api.active().post(this.removeSharesUrl, {
        shares: this.selectedShares,
      }).then((response) => {
        this.resetSelectedOrganizations()

        this.$store.commit('baseAddNotification', {
          type: 'success',
          title: 'Success',
          text: response.data.message,
        })

        this.fetch()
      })
    },
    openSendToOrganizationsModal() {
      this.$store.commit('documentOpenSendToOrganizationsModal', this.resource)
    },
    selectAll() {
      this.selectedShares = _.map(this.organizations, 'uuid')
    },
    selectNone() {
      this.resetSelectedOrganizations()
    },
    resetSelectedOrganizations() {
      this.selectedShares = []
    },
  },
}
</script>
